import Button from '../../design-system/primitives/Button.jsx'
import { NIGHT_OFF_TYPES } from '../../utils/nightOff.js'
import './planner.css'

/**
 * Shared subtype chips (+ optional Save) for overlay and resolve prompt.
 */
export default function NightOffPicker({
  selected = null,
  onSelect,
  onSave = null,
  saveDisabled = false,
  commitOnSelect = false,
  hint = null,
}) {
  return (
    <div className="night-off-picker">
      <div className="night-off-chip-row" role="group" aria-label="Night off type">
        {NIGHT_OFF_TYPES.map((type) => {
          const active = selected === type.id
          return (
            <button
              key={type.id}
              type="button"
              className={`night-off-chip${active ? ' is-selected' : ''}`}
              aria-pressed={active}
              onClick={() => {
                onSelect?.(type.id)
                if (commitOnSelect) void onSave?.(type.id)
              }}
            >
              {type.label}
            </button>
          )
        })}
      </div>
      {(onSave && !commitOnSelect) || hint ? (
        <div className="night-off-picker-footer">
          {hint ? <p className="night-off-hint">{hint}</p> : <span />}
          {onSave && !commitOnSelect ? (
            <Button
              variant="primary"
              className="night-off-save-btn"
              disabled={saveDisabled || !selected}
              onClick={() => selected && onSave(selected)}
            >
              Save night off
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
